<template>
  <div class="author-avatar" :style="sizeStyle">
    <img :src="src" alt="" />
  </div>
</template>

<script>
export default {
  name: 'AuthorAvatar',
  props: {
    src: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 32,
    },
  },
  computed: {
    sizeStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        minWidth: `${this.size}px`,
        minHeight: `${this.size}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.author-avatar {
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
}
</style>
